import React from 'react';

const HomeLink = () => {
	const url = new URL(process.env.REACT_APP_WEBSITE_URL);

	return (
		<a
			href={url.href}
			target="_blank"
			rel="noopener noreferrer"
			title={url.hostname}
		>
			{url.hostname}
		</a>
	);
};

export default HomeLink;
